import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

const BenefitsBentoGrid = ({ sectionConfig = {}, layoutContext = {}, globalConfig = {} }) => {
    const { applyHoverEffect, removeHoverEffect, getIcon, getAnimationProps } = layoutContext;
    const items = sectionConfig.items || [];

    if (!items.length) {
        return null;
    }

    const applyAnimation = (animationConfig, index = 0) => (
        typeof getAnimationProps === 'function' ? getAnimationProps(animationConfig, index) : {}
    );
    const sectionAnimation = applyAnimation(sectionConfig.animation?.section);
    const titleAnimation = applyAnimation(sectionConfig.animation?.title);

    return (
        <Box
            id="benefits-section"
            className={sectionAnimation.className}
            data-anim={sectionAnimation.dataAnim}
            data-delay={sectionAnimation.dataDelay}
            data-trigger-once={sectionAnimation.dataTriggerOnce}
            style={{ ...(sectionConfig.styles || {}), ...(sectionAnimation.style || {}) }}
        >
            <Container maxWidth={sectionConfig.container?.maxWidth || 'lg'} style={sectionConfig.containerStyles || {}}>
                <Box
                    className={titleAnimation.className}
                    data-anim={titleAnimation.dataAnim}
                    data-delay={titleAnimation.dataDelay}
                    data-trigger-once={titleAnimation.dataTriggerOnce}
                    style={{ ...(sectionConfig.titleContainerStyles || {}), ...(titleAnimation.style || {}) }}
                >
                    {sectionConfig.label && (
                        <Typography variant={sectionConfig.typography?.label?.variant || 'body2'} style={sectionConfig.labelStyles || {}}>
                            {sectionConfig.label}
                        </Typography>
                    )}
                    <Typography variant={sectionConfig.typography?.title?.variant || 'h2'} style={sectionConfig.titleStyles || {}}>
                        {sectionConfig.title || globalConfig.benefits?.title}
                    </Typography>
                    {sectionConfig.subtitle && (
                        <Typography variant={sectionConfig.typography?.subtitle?.variant || 'body1'} style={sectionConfig.subtitleStyles || {}}>
                            {sectionConfig.subtitle}
                        </Typography>
                    )}
                </Box>
                <Box
                    style={{
                        display: 'grid',
                        gridTemplateColumns: sectionConfig.grid?.templateColumns || 'repeat(3, 1fr)',
                        gridTemplateRows: sectionConfig.grid?.templateRows || 'auto auto',
                        gap: `${(sectionConfig.grid?.spacing || 1.5) * 8}px`,
                        width: '100%',
                        ...(sectionConfig.grid?.styles || {})
                    }}
                >
                    {items.map((benefit, index) => {
                        const cardAnimation = applyAnimation(sectionConfig.animation?.items, index);
                        return (
                        <Box
                            key={`benefit-${index}`}
                            style={{
                                gridColumn: benefit.gridSpan ? `span ${benefit.gridSpan}` : 'span 1',
                                gridRow: benefit.gridRowSpan ? `span ${benefit.gridRowSpan}` : 'span 1'
                            }}
                        >
                            <Box
                                className={cardAnimation.className}
                                data-anim={cardAnimation.dataAnim}
                                data-delay={cardAnimation.dataDelay}
                                data-trigger-once={cardAnimation.dataTriggerOnce}
                                style={{
                                    ...sectionConfig.cardStyles,
                                    backgroundColor: benefit.backgroundColor || sectionConfig.cardStyles?.background,
                                    padding: benefit.padding || sectionConfig.cardStyles?.padding,
                                    height: benefit.height || sectionConfig.cardStyles?.height || '330px',
                                    ...(cardAnimation.style || {})
                                }}
                                onMouseEnter={(event) => applyHoverEffect?.(event, sectionConfig.cardHoverStyles || {})}
                                onMouseLeave={(event) => removeHoverEffect?.(event, sectionConfig.cardStyles || {})}
                            >
                                <Box
                                    style={{
                                        position: 'relative',
                                        zIndex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%'
                                    }}
                                >
                                    <Box
                                        style={{
                                            ...(sectionConfig.iconBoxStyles || {}),
                                            backgroundColor: benefit.iconBackgroundColor || sectionConfig.iconBoxStyles?.backgroundColor,
                                            color: benefit.iconColor || sectionConfig.iconBoxStyles?.color
                                        }}
                                    >
                                        {getIcon?.(benefit.icon, { fontSize: benefit.iconSize || '1.5rem' })}
                                    </Box>
                                    <Typography style={{ ...(sectionConfig.titleItemStyles || {}), fontSize: benefit.titleFontSize || sectionConfig.titleItemStyles?.fontSize || '1.5rem' }}>
                                        {benefit.title}
                                    </Typography>
                                    <Typography style={sectionConfig.descriptionStyles || {}}>
                                        {benefit.description}
                                    </Typography>
                                </Box>
                                <Box
                                    data-bg-icon
                                    style={{
                                        ...(sectionConfig.backgroundIconStyles || {}),
                                        fontSize: benefit.backgroundIconFontSize || sectionConfig.backgroundIconStyles?.fontSize || '140px',
                                        color: benefit.backgroundIconColor || benefit.iconBackgroundColor || sectionConfig.backgroundIconStyles?.color
                                    }}
                                >
                                    {getIcon?.(benefit.icon, {
                                        style: { fontSize: 'inherit' }
                                    })}
                                </Box>
                            </Box>
                        </Box>
                        );
                    })}
                </Box>
            </Container>
        </Box>
    );
};

export default BenefitsBentoGrid;
